import React from 'react';

function PrintCartLinkTemplate () {

	return <>Print</>;

}

export default PrintCartLinkTemplate;
